import type { MetricsTranslations } from "../interfaces/metrics";

export const metricsTranslations: MetricsTranslations = {
  page_title: "Métricas",
  page_description:
    "El dinero que mueven las billeteras, OTC y las tarjetas, cómo llegan y operan los clientes, el uso de la plataforma y los experimentos, en todas las organizaciones.",
  tab_otc: "OTC",
  tab_experiments: "Experimentos",
  refresh: "Actualizar",
  period_label: "Periodo",
  period_option: "{{days}} días",
  window_caption: "Del {{from}} al {{to}}, comparado con los {{days}} días anteriores.",
  error_title: "No pudimos cargar las métricas",
  error_text: "Vuelve a intentarlo en un momento.",
  error_retry: "Reintentar",
  kpi_volume: "Volumen",
  kpi_ticket: "Ticket promedio",
  change_vs_previous: "{{change}} vs {{days}} días anteriores",
  change_none: "Sin datos del periodo anterior",
  top_hint: "Por volumen en el periodo.",
  col_user: "Usuario",
  col_organization: "Organización",
  col_transactions: "Transacciones",
  col_volume: "Volumen",
  col_ticket: "Ticket promedio",
  via_api: "Vía API",
  top_empty: "Nadie operó en este periodo.",
  experiments_description: "Pruebas A/B: cada usuario ve siempre la misma versión mientras la prueba corre.",
  experiments_empty: "Todavía no hay experimentos.",
  col_experiment: "Experimento",
  col_status: "Estado",
  col_split: "Reparto",
  col_users: "Usuarios",
  col_started: "Inicio",
  status_RUNNING: "En curso",
  status_PAUSED: "Pausado",
  status_ROLLED_OUT: "Encendido para todos",
  experiment_otc_volume_discount: "Banner de descuento por volumen (compra y venta de USDT)",
  variant_otc_volume_discount_control: "Sin banner",
  variant_otc_volume_discount_treatment: "Con banner",
  variant_users: "{{variant}}: {{users}}",
  detail_back: "Experimentos",
  detail_since: "Desde el {{date}}",
  detail_until: "Hasta el {{date}}",
  detail_not_found: "No encontramos ese experimento.",
  detail_no_metric: "Este experimento todavía no tiene métricas.",
  detail_how_to_read:
    "La conversión es la parte de los usuarios que compró al menos una vez desde que entró a la prueba. Con menos de 30 usuarios por grupo, toma la diferencia como una tendencia.",
  group_users: "Usuarios",
  group_conversion_rate: "Conversión",
  group_average: "Valor promedio",
  significance_significant: "Diferencia significativa",
  significance_trend: "Aún no es concluyente",
  significance_not_enough: "Faltan datos",
  action_pause: "Pausar",
  action_resume: "Reanudar",
  action_rollout: "Encender para todos",
  confirm_pause_title: "¿Pausar el experimento?",
  confirm_pause_text:
    "Todos verán la versión de control. Las asignaciones se conservan y el análisis se detiene aquí.",
  confirm_resume_title: "¿Reanudar el experimento?",
  confirm_resume_text: "Cada usuario vuelve a su grupo y los nuevos se asignan al azar.",
  confirm_rollout_title: "¿Encender para todos?",
  confirm_rollout_text:
    "Todos verán la versión «{{variant}}», también quienes estaban en el otro grupo. El análisis se cierra aquí.",
  confirm_cancel: "Cancelar",
  toast_updated: "Experimento actualizado",
  toast_failed: "No pudimos actualizar el experimento",
  action_split: "Cambiar reparto",
  detail_split: "Reparto: {{split}}",
  split_title: "Cambiar reparto",
  split_description: "Qué parte de los usuarios nuevos ve cada versión.",
  split_presets_label: "Usuarios nuevos en «{{variant}}»",
  split_input_label: "{{variant}} (%)",
  split_invalid_number: "Escribe un número entero entre 0 y 100.",
  split_total: "Total: {{total}} %",
  split_total_error: "Suma {{total}} %; tiene que sumar 100 %.",
  split_keep_note:
    "Quien ya tiene una versión la conserva. El nuevo reparto aplica a quien llegue desde ahora.",
  split_save: "Guardar reparto",
  toast_split_updated: "Reparto actualizado",
  toast_split_failed: "No pudimos cambiar el reparto",
  user_section_title: "Versión por usuario",
  user_section_hint:
    "Busca a alguien por nombre o correo para ver qué versión tiene, aunque todavía no haya cotizado, y cambiarla. Una versión fija se ve siempre, aunque el experimento esté pausado, y no cuenta en los resultados.",
  user_not_found: "No encontramos un usuario con ese correo.",
  user_lookup_failed: "No pudimos consultar ese usuario.",
  user_sees: "Ve: {{variant}}",
  source_forced: "Versión fijada por staff.",
  source_assigned: "Le tocó al azar el {{date}}.",
  source_not_assigned: "Todavía no ha cotizado: esta es la versión que le tocará.",
  source_staff: "Es staff: ve la versión que se está probando.",
  source_paused: "El experimento está pausado: ve la versión de control.",
  source_rolled_out: "El experimento está encendido para todos.",
  user_force: "Fijar en «{{variant}}»",
  force_otc_volume_discount_treatment: "Activar banner",
  force_otc_volume_discount_control: "Quitar banner",
  user_release: "Volver al sorteo",
  user_release_hint: "Al volver al sorteo verá «{{variant}}».",
  toast_forced: "{{email}} ahora ve «{{variant}}»",
  toast_released: "{{email}} volvió al sorteo",
  toast_override_failed: "No pudimos cambiar la versión",
  overrides_title: "Usuarios con versión fija",
  overrides_since: "Desde el {{date}}",
  group_average_otc_trade: "Ticket promedio",
  overview_volume: "Volumen total",
  overview_operations: "Operaciones",
  overview_users: "Usuarios activos",
  daily_title_volume: "Volumen por día",
  daily_title_operations: "Operaciones por día",
  daily_hint: "Cada día, las compras (de USDT y recargas de tarjeta, una sobre otra) junto a las ventas.",
  daily_measure_label: "Medida",
  side_buy_short: "Compras",
  side_sell_short: "Ventas",
  side_card_top_up_short: "Tarjetas",
  measure_volume: "Volumen",
  measure_operations: "Operaciones",
  sides_title: "Compras, tarjetas y ventas",
  sides_hint: "Cada lado frente a sus {{days}} días anteriores.",
  col_metric: "Métrica",
  top_title: "Quiénes más operan",
  top_tab_buy: "Compran más",
  top_tab_sell: "Venden más",
  top_tab_card_top_up: "Recargan tarjetas",
  verdict_title: "Resultado hasta hoy",
  verdict_headline_up: "«{{variant}}» convierte {{change}} más que «{{against}}»",
  verdict_headline_down: "«{{variant}}» convierte {{change}} menos que «{{against}}»",
  verdict_headline_equal: "«{{variant}}» y «{{against}}» convierten igual",
  verdict_rates:
    "Operó el {{variantRate}} de los usuarios «{{variant}}», frente al {{againstRate}} de «{{against}}».",
  verdict_significant: "La diferencia es significativa (p = {{p}}): es difícil que sea azar.",
  verdict_trend: "Todavía puede ser azar (p = {{p}}). Deja correr la prueba.",
  verdict_not_enough:
    "Faltan datos: cada grupo necesita al menos 30 usuarios. Toma la diferencia como una tendencia.",
  verdict_empty: "Todavía nadie ha operado en la prueba.",
  col_difference: "Diferencia",
  currency_label: "Moneda",
  currency_info_label: "Qué es USD aquí",
  currency_info:
    "En USD ves los USDT comprados y vendidos (1 USDT ≈ 1 USD). El precio por USD siempre va en pesos.",
  info_label: "Qué incluye: {{metric}}",
  sides_split: "Compras {{buy}} · Tarjetas {{cards}} · Ventas {{sell}}",
  info_volume:
    "Compras, recargas de tarjeta y ventas completadas en el periodo. Una compra o una recarga de tarjeta suma los pesos que pagó el cliente, con comisión; una venta, los pesos que pagamos a su llave, antes de nuestra comisión. En USD, los USDT entregados y recibidos.",
  overview_net_flow: "Flujo neto",
  info_net_flow:
    "Compras y recargas de tarjeta menos ventas, en la moneda elegida. Positivo: los clientes se llevaron más USDT de los que trajeron. Negativo: trajeron más de los que se llevaron.",
  net_flow_buy: "Compraron más de lo que vendieron",
  net_flow_sell: "Vendieron más de lo que compraron",
  net_flow_even: "Compraron lo mismo que vendieron",
  info_operations:
    "Compras pagadas (USDT entregados), recargas de tarjeta entregadas (USDT enviados a la tarjeta) y ventas completadas (pesos acreditados) en el periodo. Las que fallaron o vencieron no cuentan aquí: están en «No completadas».",
  overview_users_new: "Nuevos: {{users}}",
  info_users:
    "Quienes completaron al menos una compra, recarga de tarjeta o venta en el periodo; una operación por API cuenta como su organización. Nuevo: su primera operación de siempre cayó en este periodo.",
  daily_difference: "Compras − ventas: {{value}}",
  daily_purchases_total: "Compras",
  daily_segment_usdt: "Compra de USDT",
  daily_segment_cards: "Recarga de tarjeta",
  daily_cards_share: "Recargas de tarjeta: {{share}} de las compras del periodo.",
  side_label: "Lado",
  prices_title: "Precio por USD",
  prices_hint: "Lo que el cliente pagó o recibió por cada USDT, con comisiones, ponderado por volumen.",
  prices_buy: "Compraron a",
  prices_sell: "Vendieron a",
  prices_card_top_up: "Recargaron tarjetas a",
  prices_spread: "Diferencia",
  prices_spread_meta: "{{percent}} sobre el precio de venta",
  info_spread:
    "Precio de compra menos precio de venta: lo que separa a quien compra de quien vende, con nuestras comisiones y el margen de liquidez incluidos.",
  prices_empty: "Sin compras ni ventas en este periodo: no hay precio que mostrar.",
  info_price:
    "Pesos por cada USDT, con comisiones, ponderado por volumen. Compra: pesos debitados ÷ USDT recibidos. Recarga de tarjeta: pesos debitados ÷ USDT enviados a la tarjeta, antes de la comisión de depósito de la tarjeta. Venta: pesos acreditados ÷ USDT vendidos.",
  info_volume_side:
    "Compra y recarga de tarjeta: los pesos que pagó el cliente, con comisión (en USD, los USDT entregados). Venta: los pesos que pagamos a su llave, antes de nuestra comisión (en USD, los USDT recibidos).",
  info_ticket: "Volumen dividido entre operaciones, en la moneda elegida.",
  row_duration: "Tiempo real",
  duration_p90: "9 de cada 10 en menos de {{time}}",
  info_duration:
    "Mediana del periodo. Compra: desde que se crea hasta que se entregan los USDT. Recarga de tarjeta: desde que se crea hasta que los USDT llegan a la dirección de la tarjeta, sin lo que tarda la tarjeta en acreditarlos. Venta: desde que llega el depósito hasta que pagamos los pesos; puede sumar hasta un minuto por la frecuencia con que la revisamos.",
  row_estimate: "Tiempo que ve el cliente",
  estimate_network: "{{network}}: {{time}}",
  estimate_none: "Sin estimado",
  info_estimate:
    "Lo que la pantalla de compra o venta le muestra hoy al cliente, por red. Sale de las operaciones recientes, no de este periodo. Las recargas de tarjeta muestran su propia espera, en la tarjeta.",
  row_not_completed: "No completadas",
  not_completed_rate: "{{rate}} de las que terminaron",
  info_not_completed:
    "Compras y recargas de tarjeta fallidas, canceladas o revertidas, y ventas vencidas sin depósito o devueltas, que terminaron en el periodo. El porcentaje es sobre todas las que terminaron, completadas o no.",
  reason_count: "{{reason}}: {{total}}",
  reason_failed: "Fallida",
  reason_cancelled: "Cancelada",
  reason_reversed: "Revertida",
  reason_expired: "Vencida sin depósito",
  reason_refunding: "Devolviendo",
  reason_refunded: "Devuelta",
  users_split: "Nuevos: {{new}} · Recurrentes: {{returning}}",
  info_users_side:
    "Quienes completaron al menos una operación de ese lado; por API cuenta la organización. Nuevo: su primera operación de ese lado cayó en este periodo.",
  conversion_split: "{{converted}} de {{quoted}} que cotizaron",
  info_conversion:
    "Por usuario, no por cotización: quien cotizó diez veces y compró una vez convirtió. Cuentan los usuarios de las organizaciones; el staff no, porque sus cotizaciones suelen ser pruebas. Las recargas de tarjeta no se cotizan en la mesa, así que no tienen conversión.",
  intent_title: "Quién cotizó y qué operó",
  intent_hint: "La cotización más grande de cada usuario frente a lo que terminó operando en el periodo.",
  intent_quoted: "Cotizaron",
  intent_converted: "Operaron",
  intent_captured: "Capturado",
  intent_captured_meta: "{{traded}} de {{quoted}} cotizados",
  info_captured:
    "Lo que operaron quienes cotizaron, frente a la suma de la cotización más grande de cada uno. Pasa de 100 % si operaron más de lo que cotizaron.",
  intent_list_hint: "Los 10 con la cotización más grande.",
  col_quotes: "Cotizaciones",
  col_max_quote: "Cotización más grande",
  col_traded: "Operado",
  quoter_traded: "Operó",
  quoter_not_traded: "No operó",
  quoter_last: "Última cotización: {{date}}",
  intent_empty: "Nadie cotizó en este periodo.",
  user_search_label: "Usuario",
  user_search_placeholder: "Nombre o correo",
  user_search_hint: "Escribe al menos 3 letras.",
  user_search_searching: "Buscando…",
  user_search_empty: "Nadie coincide con esa búsqueda.",
  user_search_failed: "No pudimos buscar. Vuelve a intentarlo.",
  user_would_see: "Le tocaría: {{variant}}",
  summary_title: "Resumen por versión",
  col_variant: "Versión",
  summary_baseline: "Referencia",
  tab_tpv: "TPV",
  reason_rejected: "Rechazada",
  tpv_overview_tpv: "TPV",
  tpv_info_tpv:
    "Cobros confirmados más dispersiones pagadas, en dólares a la tasa del día de cada operación. Los swaps y las recargas de Coloca no suman.",
  tpv_split: "Entra {{in}} · sale {{out}}",
  tpv_overview_revenue: "Ingresos de Coloca",
  tpv_info_revenue:
    "La comisión de Coloca en cobros y dispersiones, la comisión de conversión (dispersiones entre monedas y swaps) y el resultado de ejecución de la mesa en las compras de USDT, que finanzas aún no valida. No resta costos de proveedor ni impuestos que asume Coloca.",
  tpv_take_rate_value: "Take rate {{rate}}",
  tpv_ticket_value: "Ticket promedio {{ticket}}",
  tpv_overview_organizations: "Organizaciones activas",
  tpv_info_organizations:
    "Organizaciones con al menos un cobro o una dispersión en el periodo. Nuevas: su primera operación de la historia cae en el periodo.",
  tpv_organizations_new: "{{organizations}} nuevas",
  tpv_flow_title: "Por dónde entra y sale el dinero",
  tpv_flow_hint:
    "El TPV del periodo por producto: a la izquierda lo que entra a las billeteras, a la derecha lo que sale.",
  tpv_flow_in: "Entra",
  tpv_flow_out: "Sale",
  tpv_flow_net_in: "Entró {{amount}} más de lo que salió",
  tpv_flow_net_out: "Salió {{amount}} más de lo que entró",
  tpv_flow_net_even: "Entró lo mismo que salió",
  tpv_flow_empty: "No hubo cobros ni dispersiones en este periodo.",
  tpv_flow_aria: "Entraron {{in}} y salieron {{out}}",
  tpv_flow_share: "{{share}} de lo que se movió",
  tpv_product_collection: "Cobros",
  tpv_product_otc_sell: "Venta de USDT",
  tpv_product_payout: "Dispersiones",
  tpv_product_otc_buy: "Compra de USDT",
  tpv_product_card_top_up: "Recarga de tarjetas",
  tpv_daily_title_volume: "TPV por día",
  tpv_daily_title_operations: "Operaciones por día",
  tpv_daily_hint: "Cobros y dispersiones de cada día, en dólares a la tasa de ese día.",
  tpv_series_in: "Cobros",
  tpv_series_out: "Dispersiones",
  tpv_daily_net: "Neto: {{value}}",
  tpv_flows_title: "Flujos",
  tpv_flows_hint:
    "Cobros y dispersiones forman el TPV; swaps y recargas de Coloca van aparte. Cada cifra frente a los {{days}} días anteriores.",
  tpv_flow_payins: "Cobros",
  tpv_flow_payouts: "Dispersiones",
  tpv_flow_fx: "Swaps",
  tpv_flow_top_ups: "Recargas Coloca",
  tpv_row_operations: "Operaciones",
  tpv_info_operations:
    "Cobros confirmados, dispersiones pagadas, swaps y recargas, por la fecha en que se completaron.",
  tpv_row_volume: "Volumen",
  tpv_info_volume:
    "En dólares a la tasa del día de cada operación: lo que envió el pagador en un cobro, lo que salió de la billetera en una dispersión o un swap, comisión de conversión incluida.",
  tpv_row_ticket: "Ticket promedio",
  tpv_info_ticket: "Volumen entre operaciones convertidas a dólares.",
  tpv_row_revenue: "Ingresos",
  tpv_revenue_service: "Comisión {{amount}}",
  tpv_revenue_conversion: "Conversión {{amount}}",
  tpv_revenue_fx_execution: "Ejecución OTC {{amount}}",
  tpv_row_take_rate: "Take rate",
  tpv_info_take_rate:
    "Ingresos sobre volumen. En el total, todos los ingresos (también los de swaps) sobre el TPV.",
  tpv_row_organizations: "Organizaciones",
  tpv_row_not_completed: "No completadas",
  tpv_info_not_completed:
    "Cobros rechazados, fallidos o revertidos y dispersiones fallidas, canceladas o revertidas, por cuándo terminaron. Los cobros que nadie pagó y vencieron van aparte.",
  tpv_row_expired: "Cobros vencidos",
  tpv_info_expired:
    "QR o CLABE que nadie pagó y que el sistema cerró al vencer. No es un fallo: es un cobro que no se usó.",
  tpv_row_in_flight: "En curso ahora",
  tpv_info_in_flight:
    "Cobros detectados sin confirmar y dispersiones creadas o en el proveedor, en este momento y a la tasa de hoy.",
  tpv_in_flight_value: "{{operations}} · {{amount}}",
  tpv_unconverted: "{{operations}} sin tasa, fuera de los dólares",
  tpv_corridors_title: "Productos y corredores",
  tpv_corridors_hint: "Cada cobro y dispersión por producto, rail, país y moneda, de mayor a menor volumen.",
  tpv_col_product: "Producto",
  tpv_col_rail: "Rail",
  tpv_col_country: "País",
  tpv_col_currency: "Moneda",
  tpv_col_operations: "Operaciones",
  tpv_col_volume: "Volumen",
  tpv_col_revenue: "Ingresos",
  tpv_col_share: "Participación",
  tpv_col_change: "Cambio",
  tpv_direction_in: "Entra",
  tpv_direction_out: "Sale",
  tpv_corridors_empty: "No hubo cobros ni dispersiones en este periodo.",
  tpv_fx_pairs_title: "Swaps por par",
  tpv_col_pair: "Par",
  tpv_custody_title: "Saldos en custodia",
  tpv_custody_hint:
    "Lo que tienen hoy las billeteras de pago, valorado a la última tasa conocida. La variación neta sale del libro contable.",
  tpv_custody_available: "Disponible",
  tpv_info_custody_available: "Saldo que las organizaciones pueden usar ya.",
  tpv_custody_pending: "Pendiente",
  tpv_info_custody_pending: "Cobros detectados que aún no se confirman.",
  tpv_custody_blocked: "Bloqueado",
  tpv_info_custody_blocked: "Reservado por dispersiones que siguen en curso; ya salió del saldo disponible.",
  tpv_custody_wallets: "Billeteras",
  tpv_info_custody_wallets:
    "Billeteras de pago de todas las organizaciones. Activas: organización y moneda con un cobro, dispersión o swap en el periodo.",
  tpv_custody_wallets_meta: "{{active}} activas · {{new}} nuevas",
  tpv_col_net_change: "Variación neta",
  tpv_info_net_change:
    "Créditos menos débitos de las billeteras en esa moneda durante el periodo, según el libro contable. Incluye reversos y ajustes, así que no cuadra con la foto de hoy.",
  tpv_custody_wallet_count: "{{wallets}} billeteras",
  tpv_custody_no_rate: "Sin tasa",
  tpv_custody_empty: "No hay billeteras de pago.",
  tpv_col_tpv: "TPV",
  tpv_col_payins: "Cobros",
  tpv_col_payouts: "Dispersiones",
  tpv_unnamed_organization: "Sin nombre",
  tpv_rates_title: "Tasas a dólares",
  tpv_rates_info:
    "Cada monto se convierte con la tasa a dólares de su propio día, tomada del histórico de tasas. USD y USDT valen 1. Un día sin tasa propia usa la del día conocido más cercano.",
  tpv_rates_filled: "{{share}} de los días con operaciones usó la tasa del día más cercano.",
  tpv_rates_exact: "Todos los días con operaciones tienen su propia tasa.",
  tpv_rates_missing: "Sin tasa, fuera de los dólares: {{currencies}}.",
  tpv_rates_latest: "Última tasa: {{date}}.",
  tpv_filter_label: "Organización",
  tpv_filter_all: "Todas las organizaciones",
  tpv_filter_all_hint: "Cada cifra suma todas las organizaciones.",
  tpv_filter_org_hint:
    "Cada cifra es solo de esta organización: flujos, corredores, saldos y la serie diaria.",
  tpv_organizations_title: "Organizaciones",
  tpv_organizations_hint:
    "Todas las que tuvieron un cobro, una dispersión o un swap en el periodo o en el anterior. Las que dejaron de operar quedan al final.",
  tpv_organizations_search: "Buscar por nombre o id",
  tpv_organizations_sort_label: "Ordenar por",
  tpv_sort_tpv: "TPV",
  tpv_sort_operations: "Operaciones",
  tpv_sort_revenue: "Ingresos",
  tpv_organizations_show_all: "Ver todas ({{organizations}})",
  tpv_organizations_show_less: "Ver solo las 10 primeras",
  tpv_organizations_empty: "Ninguna organización operó en este periodo.",
  tpv_organizations_no_match: "Ninguna organización coincide con «{{term}}».",
  tpv_col_transactions: "Transacciones",
  tpv_previous_value: "Antes {{amount}}",
  tpv_action_only_this: "Ver solo esta",
  tpv_action_only_this_aria: "Ver la página solo para {{organization}}",
  tpv_action_payins: "Cobros ({{operations}})",
  tpv_action_payouts: "Dispersiones ({{operations}})",
  tpv_action_view_transactions: "Ver transacciones",
  tpv_corridors_link_note:
    "«Ver transacciones» filtra por rail: en Bre-B también salen las ventas de USDT, y en USDT las compras y las recargas de tarjeta van juntas.",
  tab_home: "Resumen",
  tab_cards: "Tarjetas",
  tab_users: "Usuarios",
  home_view_detail: "Ver detalle",
  home_section_error: "No pudimos cargar esta sección.",
  home_tpv_volume: "TPV",
  home_tpv_revenue: "Ingresos de Coloca",
  home_tpv_organizations: "Organizaciones activas",
  home_otc_volume: "Volumen",
  home_otc_operations: "Operaciones",
  home_otc_users: "Usuarios activos",
  home_cards_spend: "Gasto",
  home_cards_active: "Tarjetas activas",
  home_cards_approval: "Aprobación",
  home_users_registered: "Registros",
  home_users_approved: "KYC aprobados",
  home_users_first: "Primera transacción",
  home_attention_title: "Para revisar",
  home_attention_hint: "Lo que se salió de lo normal en el período, con el enlace a donde se resuelve.",
  home_attention_empty: "Nada fuera de lo normal en el período.",
  home_attention_loading: "Revisando las secciones…",
  attention_verified_without_transaction:
    "{{total}} clientes con KYC aprobado y sin ninguna transacción hace más de {{days}} días",
  attention_kyc_in_review_stale: "{{total}} verificaciones KYC en revisión hace más de {{days}} días",
  attention_card_approval_drop: "La aprobación de tarjetas bajó {{points}}",
  attention_card_approval_reason: "{{reason}} explica el {{share}} de los rechazos",
  attention_card_spend_drop: "El gasto con tarjetas cambió {{change}} frente al período anterior",
  attention_tpv_up: "El TPV creció {{change}}",
  attention_tpv_down: "El TPV cayó {{change}}",
  attention_tpv_driver: "{{organization}} explica el {{share}} del cambio",
  cards_tile_spend: "Gasto",
  cards_tile_approval: "Aprobación",
  cards_tile_active_cards: "Tarjetas activas",
  cards_tile_cardholders: "Tarjetahabientes activos",
  cards_tile_loads: "Cargado",
  cards_tile_holdings: "Saldo en tarjetas",
  info_cards_spend:
    "Compras y retiros en cajero aprobados, en dólares. Una compra que se liquida cuenta una sola vez, y devolver saldo a la billetera de tarjetas no es gasto.",
  info_cards_approval:
    "Compras aprobadas sobre el total de intentos (aprobados más declinados). El cambio va en puntos porcentuales.",
  info_cards_active_cards:
    "Tarjetas con al menos una compra aprobada en el período. Al lado, las tarjetas creadas en el período.",
  info_cards_cardholders:
    "Personas con al menos una compra aprobada. Nuevos: su primera compra en Coloca fue en este período.",
  info_cards_loads:
    "Lo que entró a las tarjetas: desde la billetera de tarjetas, por depósito cripto o desde pesos (llega por Polygon).",
  info_cards_holdings:
    "Lo que tienen hoy todas las tarjetas, según la última lectura al proveedor: lo que Coloca respalda.",
  cards_spend_meta: "{{purchases}} compras · ticket {{ticket}}",
  cards_declined_meta: "{{total}} declinadas",
  cards_active_cards_meta: "con al menos una compra · {{issued}} creadas",
  cards_cardholders_meta: "{{total}} nuevos este período",
  cards_loads_meta: "saldo {{wallet}} · cripto {{crypto}} · pesos {{pesos}}",
  cards_holdings_meta: "en {{total}} tarjetas con saldo",
  cards_daily_title_amount: "Gasto por día",
  cards_daily_title_count: "Compras por día",
  cards_daily_hint: "Compras aprobadas y declinadas de cada día.",
  cards_measure_amount: "Monto",
  cards_measure_count: "Compras",
  cards_series_approved: "Aprobadas",
  cards_series_declined: "Declinadas",
  cards_daily_footer: "Aprobación {{rate}}",
  cards_merchants_title: "Comercios donde más se gasta",
  cards_merchants_hint:
    "Los 10 primeros del período, por marca: los distintos nombres con que llega un mismo comercio (FACEBK *ADS, META ADS…) cuentan juntos.",
  cards_merchant_aliases: "Incluye {{names}}",
  cards_merchant_aliases_more: "Incluye {{names}} y {{more}} más",
  cards_merchants_empty: "Sin compras en el período",
  cards_merchant_card_meta: "{{purchases}} compras · {{cardholders}} tarjetahabientes",
  cards_col_merchant: "Comercio",
  cards_col_category: "Categoría",
  cards_col_spend: "Gasto",
  cards_col_purchases: "Compras",
  cards_col_share: "Del gasto",
  cards_col_cardholders: "Tarjetahabientes",
  cards_categories_title: "Por categoría",
  cards_categories_hint: "Gasto por tipo de comercio.",
  cards_category_other: "Otros",
  cards_cardholders_title: "Quiénes más gastan",
  cards_cardholders_hint: "Tarjetahabientes por gasto en el período.",
  cards_cardholders_empty: "Nadie compró en el período",
  cards_cardholders_show_all: "Ver los {{count}}",
  cards_cardholders_show_less: "Ver menos",
  cards_cardholder_card_meta:
    "{{purchases}} compras · ticket {{ticket}} · {{declined}} declinadas · última {{last}}",
  cards_col_cardholder: "Tarjetahabiente",
  cards_col_organization: "Organización",
  cards_col_cards: "Tarjetas",
  cards_col_ticket: "Ticket",
  cards_col_declined: "Declinadas",
  cards_col_last_purchase: "Última compra",
  cards_organizations_title: "Organizaciones por gasto en tarjetas",
  cards_organizations_hint: "Dónde está el volumen de tarjetas y cómo se mueve.",
  cards_organizations_empty: "Ninguna organización usó tarjetas en el período",
  cards_organization_card_meta: "{{cards}} tarjetas activas · aprobación {{approval}}",
  cards_col_active_cards: "Tarjetas activas",
  cards_col_change: "Cambio",
  cards_col_approval: "Aprobación",
  cards_declines_title: "Por qué se rechazan",
  cards_declines_hint: "{{total}} compras declinadas en el período, por motivo.",
  cards_declines_empty: "Ninguna compra declinada en el período.",
  decline_INSUFFICIENT_CARD_BALANCE: "Fondos insuficientes en la tarjeta",
  decline_INSUFFICIENT_PROVIDER_FUNDS: "Fondos insuficientes del emisor",
  decline_CARD_NOT_ACTIVE: "Tarjeta no activa",
  decline_LIMIT_EXCEEDED: "Límite superado",
  decline_MERCHANT_BLOCKED: "Comercio no permitido",
  decline_INVALID_CARD_DATA: "Datos de la tarjeta incorrectos",
  decline_SUSPECTED_FRAUD: "Sospecha de fraude",
  decline_PROVIDER_ERROR: "Error del procesador",
  decline_UNKNOWN: "Otro motivo",
  users_cohort_note:
    "Aquí un usuario es un cliente (organización): su KYC/KYB es el de la organización y su primera transacción, la primera operación de esa organización. Se excluye la organización de Coloca.",
  users_tile_registered: "Registros",
  users_tile_kyc_started: "KYC iniciado",
  users_tile_kyc_approved: "KYC aprobado",
  users_tile_first_transaction: "Primera transacción",
  users_tile_active: "Clientes activos",
  info_users_registered:
    "Organizaciones creadas en el período. Cada paso de esta página sigue a estos mismos clientes hasta hoy.",
  info_users_kyc_started:
    "De los registrados, los que iniciaron la verificación de su organización (KYC o KYB).",
  info_users_kyc_approved: "De los registrados, los que tienen la verificación aprobada hoy.",
  info_users_first_transaction:
    "De los registrados, los que ya hicieron una operación: un cobro, un envío, una compra con tarjeta o una compra o venta de USDT.",
  info_users_active: "Clientes de cualquier antigüedad que hicieron alguna operación en el período.",
  users_registered_meta: "clientes nuevos en el período",
  users_share_meta: "{{rate}} de los registros",
  users_approved_meta: "{{rate}} de los registros · {{rejected}} rechazados",
  users_active_meta: "con alguna operación en el período",
  users_step_registered: "Registro",
  users_step_email_verified: "Correo verificado",
  users_step_kyc_started: "KYC iniciado",
  users_step_kyc_in_review: "KYC en revisión",
  users_step_kyc_rejected: "KYC rechazado",
  users_step_kyc_approved: "KYC aprobado",
  users_step_first_transaction: "Primera transacción",
  users_funnel_title: "Del registro a la primera transacción",
  users_funnel_hint: "Clientes registrados en el período y hasta dónde llegaron.",
  users_funnel_empty: "Nadie se registró en el período.",
  users_funnel_of_previous: "{{rate}} del anterior",
  users_funnel_chart_title: "Embudo de clientes",
  users_funnel_chart_hint:
    "La misma cohorte vista como embudo: el ancho es la parte de los registros que llega a cada paso y, al lado, cuántos se quedan entre un paso y el siguiente.",
  users_drops_title: "Dónde se quedan",
  users_drop_row: "{{from}} → {{to}}",
  users_worst_drop: "El paso con más pérdida es de {{from}} a {{to}}: {{lost}} de {{total}} clientes.",
  users_durations_title: "Cuánto tardan",
  users_durations_hint: "Mediana y el 90 % más lento (p90) entre cada paso.",
  users_col_step: "Paso",
  users_col_median: "Mediana",
  users_col_p90: "p90",
  users_col_samples: "Clientes",
  span_minutes: "{{value}} min",
  span_hours: "{{value}} h",
  span_days: "{{value}} días",
  users_first_title: "Qué hacen primero",
  users_first_hint: "El producto de la primera transacción de cada cliente nuevo.",
  users_first_empty: "Ningún cliente nuevo operó todavía.",
  users_product_payin: "Cobro",
  users_product_payout: "Envío",
  users_product_otc_buy: "Compra de USDT",
  users_product_otc_sell: "Venta de USDT",
  users_product_card: "Compra con tarjeta",
  users_recent_title: "Registros recientes",
  users_recent_hint:
    "En qué paso está cada cliente nuevo y hace cuánto. Los que llevan más de {{days}} días en un paso se marcan.",
  users_recent_empty: "Todavía no hay registros",
  users_recent_card_meta: "Registro {{registered}} · último ingreso {{login}}",
  users_col_client: "Cliente",
  users_col_registered: "Registro",
  users_col_stage: "Paso actual",
  users_col_in_stage: "En el paso",
  users_col_last_login: "Último ingreso",
  users_in_stage_days: "{{count}} días",
  tab_platform: "Plataforma",
  monthly_in_progress: "en curso",
  monthly_trend: "{{lastMonth}}: {{last}}. Contra {{firstMonth}}:",
  org_scope_note: "Solo {{name}}. Las comparaciones entre organizaciones se ocultan.",
  org_scope_note_otc: "Solo {{name}}: cifras, gráficas y usuarios de esa organización.",
  cards_monthly_title: "Gasto por mes",
  cards_monthly_hint: "Los últimos 12 meses de todas las organizaciones. El mes en curso va incompleto.",
  cards_monthly_hint_org: "Los últimos 12 meses de {{name}}. El mes en curso va incompleto.",
  cards_series_spend: "Gasto",
  cards_series_purchases: "Compras",
  cards_holders_title: "Quién tiene más saldo",
  cards_holders_hint:
    "Las 15 organizaciones con más saldo hoy: su wallet de tarjetas más lo cargado en sus tarjetas.",
  cards_holders_wallet: "Wallet de tarjetas",
  cards_holders_cards: "En tarjetas",
  cards_holders_share: "{{share}} del total",
  cards_holders_empty: "Ninguna organización tiene saldo en tarjetas hoy.",
  cards_holders_row_label: "{{name}}: {{wallet}} en la wallet de tarjetas y {{cards}} en tarjetas",
  cards_holders_row_detail: "Wallet {{wallet}} · {{cards}} en {{cardCount}} tarjetas",
  info_cards_holders:
    "Saldo de hoy en USD: el de la wallet de tarjetas de la organización (y sus bolsillos) más el de sus tarjetas que no comparten saldo con una wallet. El porcentaje es sobre el total de todas las organizaciones, sin la de Coloca.",
  cards_shares_title: "Quién gasta más cada mes",
  cards_shares_hint:
    "Qué parte del gasto de cada uno de los últimos 6 meses hizo cada organización, en % y en USD. El cambio compara el último mes con el primero.",
  cards_shares_col_organization: "Organización",
  cards_shares_col_total: "Total {{months}} meses",
  cards_shares_col_change: "Cambio",
  cards_shares_others: "Otras ({{total}})",
  cards_shares_empty: "Todavía no hay gasto con tarjeta en estos meses.",
  info_cards_shares:
    "Compras aprobadas en USD de cada mes calendario (hora de Colombia), sin la organización de Coloca. Se muestran las 10 que más gastaron en los 6 meses y el resto se suma en «Otras». El cambio va en puntos porcentuales.",
  users_registrations_title: "Registros por día",
  users_registrations_hint:
    "{{total}} organizaciones nuevas en los últimos {{days}} días. La línea es el mismo día del período anterior.",
  users_registrations_current: "Este período",
  users_registrations_previous: "Período anterior",
  users_activity_title: "Clientes que operan",
  users_activity_hint:
    "Desde aquí se mira a todas las organizaciones que operan, no solo a las registradas en el período. El volumen va en USD: cobros confirmados, envíos pagados y gasto con tarjeta.",
  users_movers_title: "Quién se va y quién crece",
  users_movers_hint: "Volumen de los últimos {{days}} días contra los {{days}} anteriores.",
  info_users_movers:
    "Cobros confirmados, envíos pagados y gasto con tarjeta, en USD al tipo de cambio de cada día. «Se están yendo»: movían algo en el período anterior y bajaron {{threshold}} o más, o a cero. «Crecen»: subieron al menos {{floor}}. Sin la organización de Coloca.",
  users_movers_tab_falling: "Se están yendo ({{total}})",
  users_movers_tab_growing: "Crecen ({{total}})",
  users_movers_empty_falling: "Ningún cliente bajó {{threshold}} o más en este período.",
  users_movers_empty_growing: "Ningún cliente subió {{floor}} o más en este período.",
  users_movers_more: "Se listan {{shown}} de {{total}}.",
  users_list_show_all: "Ver todos ({{total}})",
  users_list_show_less: "Ver menos",
  users_movers_before: "Antes",
  users_movers_now: "Ahora",
  users_movers_new: "nuevo",
  users_movers_stopped: "dejó de operar",
  users_movers_values: "{{before}} → {{now}}",
  users_movers_ops: "{{current}} operaciones (antes {{previous}})",
  users_movers_last: "última: {{date}}",
  users_inactive_title: "Días sin operar",
  users_inactive_hint:
    "Clientes que operaron en los últimos {{lookback}} días pero llevan {{days}} días o más sin hacerlo, los de más volumen primero.",
  users_inactive_empty: "Ningún cliente lleva {{days}} días o más sin operar.",
  users_inactive_moved: "{{amount}} en {{operations}} operaciones en {{lookback}} días",
  users_inactive_days: "{{total}} días",
  users_products_title: "Productos por cliente",
  users_products_hint:
    "Qué usan las {{organizations}} organizaciones que operaron en los últimos {{lookback}} días.",
  info_users_products:
    "Un producto está en uso si la organización lo usó en los últimos {{lookback}} días; «antes» si lo usó alguna vez, pero no en ese tiempo. Productos: cobros, envíos, compra y venta de USDT, recargas de tarjeta con pesos y gasto con tarjeta.",
  users_products_usage: "{{recent}} en uso ({{share}}) · {{ever}} alguna vez",
  users_products_by_org: "Por organización, las de más volumen primero",
  users_products_legend_recent: "En uso (últimos {{lookback}} días)",
  users_products_legend_before: "Lo usó antes",
  users_products_legend_never: "Nunca lo usó",
  users_products_col_organization: "Organización",
  users_products_col_volume: "Volumen {{lookback}} días",
  users_products_empty: "Ninguna organización operó en los últimos {{lookback}} días.",
  activity_product_collection: "Cobros",
  activity_product_payout: "Envíos",
  activity_product_otc_buy: "Compra USDT",
  activity_product_otc_sell: "Venta USDT",
  activity_product_card_top_up: "Recarga con pesos",
  activity_product_card: "Tarjetas",
  home_platform_active: "Usuarios activos",
  home_platform_session: "Tiempo por sesión",
  home_platform_top_section: "Sección más usada",
  attention_clients_falling: "{{total}} clientes bajaron su volumen {{threshold}} o más",
  attention_clients_inactive: "{{total}} clientes llevan {{days}} días o más sin operar",
  platform_audience_label: "De quién",
  platform_audience_clients: "Clientes",
  platform_audience_staff: "Staff",
  platform_tracking_none:
    "Todavía no hay visitas registradas: el uso se cuenta desde que se activó el registro. Los inicios de sesión sí traen todo el historial.",
  platform_tracking_partial:
    "Las visitas se cuentan desde el {{date}}: antes de ese día el uso sale en cero, así que las comparaciones de uso con el período anterior todavía no son justas. Los inicios de sesión traen todo el historial.",
  platform_tile_active: "Usuarios activos",
  info_platform_active: "Personas que abrieron al menos una página del dashboard en el período.",
  platform_active_meta: "De {{organizations}} organizaciones",
  platform_tile_daily: "Activos por día",
  info_platform_daily: "El promedio de personas con alguna visita cada día del período.",
  platform_daily_meta: "{{weekly}} en los últimos 7 días",
  platform_tile_sessions: "Sesiones",
  info_platform_sessions:
    "Ratos de uso de una persona en un navegador. Una sesión termina tras 30 minutos sin usar el dashboard.",
  platform_sessions_meta: "{{perUser}} por persona",
  platform_tile_session_time: "Tiempo por sesión",
  info_platform_session_time:
    "La mediana del tiempo de una sesión, contando solo los minutos con la pestaña visible y alguien usándola. Debajo, el promedio.",
  platform_session_time_meta: "Promedio {{average}}",
  platform_tile_logins: "Inicios de sesión",
  info_platform_logins: "Ingresos exitosos al dashboard o la app en el período.",
  platform_logins_meta: "De {{people}} personas",
  platform_daily_title: "Uso por día",
  platform_daily_hint: "Barras: cada día de este período. Línea: el mismo día del período anterior.",
  platform_sections_title: "Secciones más usadas",
  info_platform_sections:
    "Tiempo de uso por sección del menú: la pestaña visible y alguien usándola. El porcentaje es sobre todo el tiempo de uso del período.",
  platform_sections_hint: "Dónde se va el tiempo en el dashboard.",
  platform_section_row: "{{people}} personas · {{visits}} visitas · antes {{previous}}",
  platform_section_home: "Inicio",
  platform_section_operations: "Operaciones",
  platform_section_cards: "Tarjetas",
  platform_section_analytics: "Analítica",
  platform_section_management: "Gestión",
  platform_section_account: "Cuenta y ajustes",
  platform_section_other: "Otras",
  platform_pages_title: "Páginas más usadas",
  platform_pages_hint: "Las 15 páginas con más tiempo de uso, como las nombra el menú.",
  platform_pages_col_page: "Página",
  platform_pages_col_time: "Tiempo",
  platform_pages_col_share: "Del total",
  platform_pages_col_visits: "Visitas",
  platform_pages_col_people: "Personas",
  platform_empty_visits: "No hay visitas registradas en este período.",
  platform_heat_title_usage: "Horas de más uso",
  platform_heat_title_logins: "Horas de más inicios de sesión",
  info_platform_heatmap:
    "Día de la semana y hora de Colombia. «Uso» suma el tiempo de las visitas que empezaron en esa hora; «Inicios de sesión» cuenta los ingresos, con todo su historial.",
  platform_heat_hint: "Cuándo entran a la plataforma, por día y hora de Colombia.",
  platform_heat_peak: "El pico es el {{day}} a las {{hour}} (hora de Colombia): {{value}}.",
  platform_heat_metric_label: "Qué mide el mapa",
  platform_heat_usage: "Uso",
  platform_heat_logins: "Inicios de sesión",
  platform_heat_logins_value: "{{logins}} inicios de sesión",
  platform_heat_low: "Menos",
  platform_heat_high: "Más",
  platform_heat_idle: "Pasa el cursor por una celda para ver su valor.",
  platform_heat_empty_logins: "No hay inicios de sesión en este período.",
  platform_devices_title: "Desde dónde entran",
  info_platform_devices:
    "Cada inicio de sesión clasificado por el navegador o la app que lo hizo: computador, navegador del celular o la app móvil.",
  platform_devices_hint: "{{total}} inicios de sesión en el período.",
  platform_device_desktop_web: "Web en computador",
  platform_device_mobile_web: "Web en el celular",
  platform_device_app: "App móvil",
  platform_device_unknown: "Sin identificar",
  platform_device_row: "{{share}} · {{sessions}} ingresos · {{people}} personas",
  platform_browsers_title: "Navegadores y sistemas",
  platform_browser_row: "{{sessions}} ({{share}})",
  org_filter_hint: "Las cifras, gráficas y listas son solo de esta organización.",
  platform_measure_active: "Usuarios activos",
  platform_measure_time: "Tiempo de uso",
  platform_measure_logins: "Inicios de sesión",
  platform_series_current: "Este período",
  platform_series_previous: "Período anterior",
  platform_heat_view_label: "Qué período",
  platform_heat_view_current: "Este período",
  platform_heat_view_previous: "Anterior",
  platform_heat_view_change: "Cambio",
  platform_heat_peak_previous:
    "En el período anterior, el pico fue el {{day}} a las {{hour}} (hora de Colombia): {{value}}.",
  platform_heat_change_up: "Donde más subió: el {{day}} a las {{hour}} ({{value}}).",
  platform_heat_change_down: "Donde más bajó: el {{day}} a las {{hour}} ({{value}}).",
  platform_heat_change_none: "Ninguna hora cambió frente al período anterior.",
  platform_heat_change_low: "Menos que antes",
  platform_heat_change_high: "Más que antes",
  platform_compare_partial:
    "El uso se registra desde el {{date}}: el período anterior está incompleto, así que la comparación exagera el cambio. Los inicios de sesión sí tienen todo el historial.",
  platform_pages_col_previous: "Antes",
  platform_pages_col_change: "Cambio",
  platform_new: "nueva",
};
